//
// Copyright (C) 2025 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/RawPropValues.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/RawPropValues.proto.
 */
export const file_android_hardware_automotive_vehicle_RawPropValues: GenFile = /*@__PURE__*/
  fileDesc("CjdhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9SYXdQcm9wVmFsdWVzLnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byJ8Cg1SYXdQcm9wVmFsdWVzEhQKDGludDMyX3ZhbHVlcxgBIAMoBRIUCgxmbG9hdF92YWx1ZXMYAiADKAISFAoMaW50NjRfdmFsdWVzGAMgAygDEhMKC2J5dGVfdmFsdWVzGAQgASgMEhQKDHN0cmluZ192YWx1ZRgFIAEoCWIGcHJvdG8z");

/**
 * Must be in sync with RawPropValues.aidl. 
 *
 * @generated from message android.hardware.automotive.vehicle.proto.RawPropValues
 */
export type RawPropValues = Message<"android.hardware.automotive.vehicle.proto.RawPropValues"> & {
  /**
   * This is used for properties of types VehiclePropertyType#INT
   * and VehiclePropertyType#INT_VEC 
   *
   * @generated from field: repeated int32 int32_values = 1;
   */
  int32Values: number[];

  /**
   * This is used for properties of types VehiclePropertyType#FLOAT
   * and VehiclePropertyType#FLOAT_VEC 
   *
   * @generated from field: repeated float float_values = 2;
   */
  floatValues: number[];

  /**
   * This is used for properties of type VehiclePropertyType#INT64 
   *
   * @generated from field: repeated int64 int64_values = 3;
   */
  int64Values: bigint[];

  /**
   * This is used for properties of type VehiclePropertyType#BYTES 
   *
   * @generated from field: bytes byte_values = 4;
   */
  byteValues: Uint8Array;

  /**
   * This is used for properties of type VehiclePropertyType#STRING 
   *
   * @generated from field: string string_value = 5;
   */
  stringValue: string;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.RawPropValues.
 * Use `create(RawPropValuesSchema)` to create a new message.
 */
export const RawPropValuesSchema: GenMessage<RawPropValues> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_RawPropValues, 0);

